import type { Map } from 'mapbox-gl';

export function layerHoverCursor(map: Map, layer: string, cursor = 'pointer'): void {
  map
    .on('mouseenter', layer, () => {
      map.getCanvas().style.cursor = cursor;
    })
    .on('mouseleave', layer, () => {
      map.getCanvas().style.cursor = '';
    });
}
